import { parseMDContent } from "@/shared/utils/parse-content";
import { RendererObject } from "marked";
import { useMemo } from "react";

type Props = {
  content: string | null | undefined;
  options?: {
    replaceElement?: string;
    rendererClass?: string;
    customRenderer?: RendererObject;
  };
};

const initialOptions: Props["options"] = {
  replaceElement: "strong",
  rendererClass: "text-secondary",
  customRenderer: undefined
};

/**
 * By default we replace a strong element with the span with secondary class
 * @param options
 * @returns
 */
function getDefaultClassRenderer(options: Props["options"]): RendererObject {
  const name = options?.replaceElement || "strong";

  const renderer: any = {};

  renderer[name] = function ({ tokens }): string {
    const text = this.parser.parseInline(tokens);
    return `<span class="${options?.rendererClass}">${text}</span>`;
  };

  return renderer;
}

function ParseContent({ content, options = { ...initialOptions } }: Props) {
  const processedContent = useMemo(() => {
    // Handle null/undefined content gracefully
    if (!content) {
      return "";
    }
    const withActualNewlines = content.replace(/\\n/g, "\n");
    return withActualNewlines.replace(/\n/g, "<br />");
  }, [content]);

  let renderer: RendererObject;

  if (options?.customRenderer) {
    renderer = options.customRenderer;
  } else {
    renderer = getDefaultClassRenderer(options);
  }

  const sanitizedContent = useMemo(
    () => parseMDContent(processedContent, { renderer: renderer }),
    [processedContent, renderer]
  );

  return <>{sanitizedContent}</>;
}

export default ParseContent;
